var login = {
  translation: {
    common: {
      accept: 'Aceitar',
      alreadyUser: 'Já está registrado?',
      and: 'e',
      backToLogin: 'Voltar à página de login',
      continueWith: 'Continuar com o {{provider}}',
      createAccount: 'Criar uma conta',
      createYourAccount: 'Crie sua conta',
      emailOrUsername: 'Email ou nome de usuário',
      login: 'Login',
      logIn: 'Entrar',
      logInToBoards: 'Entrar',
      newToBoards: 'Novo no 4ga Boards?',
      pageNotFound_title: 'Página Não Encontrada',
      password: 'Senha',
      privacyPolicy: 'Política de Privacidade',
      register: 'Registrar-se',
      registerWithGoogle: 'Registrar-se com Google',
      termsOfService: 'Termos de Serviço',
      togglePasswordVisibility: 'Alternar visibilidade da senha',
    },
  },
};

export { login as default };
